import React,{useState,useEffect,useCallback} from 'react'
import classes from './VideoList.module.css'
import { GetVideos, GetVideosByCategory } from '../Services/ApiFunction'
import image from '../Assets/image.png'
import {useNavigate} from 'react-router-dom'
import Lottie from 'lottie-react'
import loader from '../Animations/Loader.json'

const VideoList = ({category,number,id}) => {

    const [videos,setVideos] = useState(null);
    const [loading,setLoading] = useState(false)
    
    const fetchData=useCallback(
        async() => {
            try{
                setLoading(true)
                const res = await GetVideos();
               
                if(number && id){
                    const allVideos = Object.values(res).flat();
                    let filteredVideos= allVideos.filter(video => video.category === category);
                    
                        if (number && id) {
                            filteredVideos = filteredVideos.filter((video) => video.id !== Number(id));
                            
                        }

                        // Shuffle the filtered videos and pick 5 random ones
                        const shuffledVideos = filteredVideos.sort(() => 0.5 - Math.random());
                        
                        const selectedVideos = shuffledVideos.slice(0, 5);
                        
                        setVideos(selectedVideos); 
                        setLoading(false);
                        return;
                }
                setVideos(res[category])
            }
            catch(err){
                // console.log(err);
                // toast.error(err.response.message)
            }
            setLoading(false);
        },
        [category,id],
    )


    // console.log(videos)

    const navigate = useNavigate()

    useEffect(()=>{
        fetchData()
    },[fetchData])
    
    const handlePlayClick=(id)=>{
        // console.log('handleplay')
        navigate(`/video/${id}`)
      }

     

  return (

    <>
    {loading ? 
    <>
    <Lottie
        animationData = {loader}
        style={{height:'20rem'}}

    />
    </>
    :
    <div className={classes.container}>
    {
        videos && videos.map((video,index)=>(
            <>
            <div className={classes.card} key={index}>
                <div className={classes.card_img}>
                {/* <img src={`https://eurekacontent.gameit.in/THUMBNAIL/${video?.category}/${video?.image_path}`} alt="" className={classes.img} loading = "lazy" /> */}
                 <img src={video.img_url} alt="" className={classes.img} loading = "lazy" />
                <button className={classes.btn} onClick={()=>handlePlayClick(video.id)}> <i className='pi pi-play' ></i>Play</button>
                </div>
                <p className={`text-gray-500 ${classes.name}`}>{video?.category}</p>
                <p className={classes.name}>{video?.content_name}</p>
            </div>
            </>
        ))
    }
    </div>
    }
    
    </>
  )
}

export default VideoList
